import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../../components/Logo/Logo';
import { apiService } from '../../services/api';
import './ForgotPassword.css';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiService.requestPasswordReset(email.trim().toLowerCase());
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao enviar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-box">
          <div className="forgot-password-logo">
            <Logo size="large" />
          </div>
          <h2 className="forgot-password-title">Verifique seu email</h2>
          <p className="forgot-password-success-text">
            Se o email <strong>{email}</strong> estiver cadastrado, você receberá um link para redefinir sua senha.
          </p>
          <p className="forgot-password-success-note">
            O link expira em 1 hora. Verifique também a pasta de spam.
          </p>
          <Link to="/login" className="forgot-password-back-link">Voltar ao login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-box">
        <div className="forgot-password-logo">
          <Logo size="large" />
        </div>
        <h2 className="forgot-password-title">Esqueci minha senha</h2>
        <p className="forgot-password-subtitle">
          Informe seu email e enviaremos um link para redefinir sua senha.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seu@email.com"
              autoFocus
            />
          </div>

          {error && <div className="forgot-password-error">{error}</div>}

          <button type="submit" disabled={loading} className="forgot-password-button">
            {loading ? 'Enviando...' : 'Enviar link'}
          </button>
        </form>

        <div className="forgot-password-info">
          <Link to="/login">Voltar ao login</Link>
        </div>
      </div>
    </div>
  );
};
